import {ILadderTeam, ISquad, IStore} from "modules/types";
import {createSelector} from "reselect";
import {mapValues, flatten, get} from "lodash";
import {getSquads} from "modules/selectors/squads";

export const getTeamsLadderStore = ({ladder}: IStore) => ladder;
export const getTeamsLadder = createSelector(getTeamsLadderStore, ({ladder}) => ladder);
export const getTeamLadderTeamsList = createSelector([getTeamsLadder, getSquads], (ladder, squads) => {
	const teamsList: ISquad[] = [];
	mapValues(ladder, (conf) => {
		const sectionsList = Object.values(conf)
			.flat()
			// @ts-ignore
			.map((team: ILadderTeam) => {
				const squad = squads.find((squad) => squad.id === String(team.team_id)) || {};
				if (squad) {
					return {
						...squad,
						seed: team.conference_rank,
					};
				}
				return team;
			});
		//Todo: check the logic here
		teamsList.push(sectionsList as unknown as ISquad);
	});
	return flatten(teamsList);
});

export const hasLadderNextLoadMore = ({ladder}: IStore): boolean => get(ladder, "next", false);
